// @ts-nocheck
import { useEffect, useMemo, useState } from "react";
//--------------------------------------------------------------------------------------------
import Esign from "src/components/common/esign";
import Esigns from "src/components/common/esigns";
import UserInfo from "src/components/common/userInfo";
import signimg from "src/img/jsa/essentialControls.png";
import mechanicalimg from "src/img/jsa/mechanical/mechanical.png";
import mechanical1img from "src/img/jsa/mechanical/mechanical1.png";
import gravity1img from "src/img/jsa/gravity/gravity1.png";
import gravity2img from "src/img/jsa/gravity/gravity2.png";
import gravityimg from "src/img/jsa/gravity/gravity.png";
import soundimg from "src/img/jsa/sound/sound.png";
import sound1img from "src/img/jsa/sound/sound1.png";
import temperatureimg from "src/img/jsa/temperature/temperature.png";
import temperature1img from "src/img/jsa/temperature/temperature1.png";
import temperature2img from "src/img/jsa/temperature/temperature2.png";
import temperature3img from "src/img/jsa/temperature/temperature3.png";
import pressureimg from "src/img/jsa/pressure/pressure.png";
import pressure1img from "src/img/jsa/pressure/pressure1.png";
import pressure2img from "src/img/jsa/pressure/pressure2.png";
import biologicalimg from "src/img/jsa/biological/biological.png";
import biological1img from "src/img/jsa/biological/biological1.png";
import electricalimg from "src/img/jsa/electrical/electrical.png";
import electrical1img from "src/img/jsa/electrical/electrical1.png";
import electrical2img from "src/img/jsa/electrical/electrical1.png";
import motionimg from "src/img/jsa/motion/motion.png";
import motion1img from "src/img/jsa/motion/motion1.png";
import motion2img from "src/img/jsa/motion/motion2.png";
import chemicalRadiationimg from "src/img/jsa/chemicalRadiation/chemicalRadiation.png";
import chemicalRadiation1img from "src/img/jsa/chemicalRadiation/chemicalRadiation1.png";
import { useAuthStore } from "src/components/main/authStore";
import {
    myAxios, 
    MyDate, 
    OtherStyle, 
    onlyUnique, 
    jsaManagers, 
    jsaOnsiteNumbers,
    arrayReducer
} from "src/components/common/functions";
import { Form, useSubmit } from "react-router-dom";

function parseMaybeJson(value, fallback){
    if(value === null || value === undefined || value === "") return fallback;
    if(typeof value === "string"){
        try{
            return JSON.parse(value);
        }catch{
            return fallback;
        }
    }
    return value;
}

function normalizeJsaContent(value){
    if(!value) return {};
    if(typeof value === "string"){
        try{
            return JSON.parse(value);
        }catch{
            return {};
        }
    }
    return value;
}
//--------------------------------------------------------------------------------------------
export default function JSAItem({
    formTitle, 
    jobSafetyAnalysisContent, 
    closeIt, 
    /*---- work ----------------------------------------*/
    workId, 
    location, 
    /*---- assignment ------------------------------------------------*/
    assignmentId, 
    projectName, 
    nearestMedicalFacility, 
    /*---- admin --------------------------------------------------*/
    adminLink, 
    /*-------------------------------------------------------------*/
    /*---- multiSite only -----------------------------------------*/
    mainLaborCategory, 
    setMainLaborCategory, 
    mainLaborName, 
    setMainLaborName, 
    helpers, 
    setHelpers, 
    formAssignmentId, 
    formId, //uid
    /*---- main only ----------------------------------------------*/
    userName, 
    laborCategory, 
}){
    const user = useAuthStore(state => state.user);
    const submit = useSubmit();
    /*-------------------------------------------------------------*/
    // signs
    const [internalPicDatas, setInternalPicDatas] = useState([]);
    const [picDatas, setPicDatas] = useState([]);
    const [picData, setPicData] = useState([]);
    /*-------------------------------------------------------------*/
    // constant
    const sifList = [
        {title: "Mechanical", img: mechanicalimg, options: [
            {title: "Heavy Rotating Equipment", img: mechanical1img, options: [
                "Physical barrier", 
                "Machine guards", 
                "2-hand switches", 
                "Automatic shut-off", 
                "Machines with sensing devices / auto-shutoff", 
                "Hair net", 
                "Safe Hand \"hand-free\" push, pull, grab tool", 
                "Tear-away finger gloves", 
                "Lock-out tag-out", 
                "Area curtains", 
                "Eye protection", 
            ]}, 
        ]}, 
        {title: "Gravity", img: gravityimg, options: [
            {title: "Suspended Load / Dropped Objects", img: gravity1img, options: [
                "Rated rigging equipment and attachment points", 
                "Load limiting devices", 
                "Hoist break", 
                "Tool tethers", 
                "Drop nets", 
                "Crawl speed on the hoist", 
                "Boom angle sensors / limiters",
                "Double rigging / redundancy",
                "Tag line retriever / Safe hand tool", 
                "Drop Zone Physical Barriers / Exclusion Zone", 
                
            ]}, 
            {title: "Fall from Elevation", img: gravity2img, options: [
                "Fall arrest system", 
                "Self-restracting lifeline", 
                "Work positioning device / restraint", 
                "Guard rails", 
                "Covers over holes / trench plates", 
                "Drop Zone Physical Barriers / Exclusion Zone", 
                
            ]}, 
        ]}, 
        {title: "Sound", img: soundimg, options: [
            {title: "Deciblel levels where permanent hearing loss can occur", img: sound1img, options: [
                "Hearing protection", 
                "Sound insulation", 
                "Rubber vibration damping", 
            ]}, 
        ]}, 
        {title: "Temperature", img: temperatureimg, options: [
            {title: "Surface Temperature", img: temperature1img, options: [
                "Physical Barriers", 
                "Lock-out tag-out", 
                "Surface insulation", 
                "De-energization with zero voltage test", 
                "Tool that forces safe distance / MAD", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Active cooling system", 
            ]}, 
            {title: "Steam", img: temperature2img, options: [
                "Physical Barriers", 
                "Lock-out tag-out", 
                "Tool that forces safe distance / MAD", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Pressure release valve", 
                "Flash-rated suit, glasses, face shield", 
                "Fire-resistant (FR) clothing", 
                "Remote racking devices", 
                "Flash protection boundary with hard physical barriers", 
                "Hot line sticks", 
            ]}, 
            {title: "Fire with Sustained Fuel Source", img: temperature3img, options: [
                "Lock-out tag-out", 
                "Surface insulation", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Fire protection system", 
                "Remote fuel shut off", 
                "Fire extinguisher / suppression", 
                "Gas detection monitoring", 
                "Sprinkler system", 
                "Self-contained breathing apparatus", 
                "Steam suits", 
                "Fire-resistant (FR) clothing", 
            ]}, 
        ]}, 
        {title: "Pressure", img: pressureimg, options: [
            {title: "Explosion / pressurized Projectiles", img: pressure1img, options: [
                "Physical barrier / Blast shield", 
                "Lock-out tag-out", 
                "Explosive ordinance disposal (EOD) suit", 
                "Rupture discs", 
                "Relef valve", 
                "Whip restraint", 
                "Inerting to exclude O2", 
                "Pressure indicators with auto shutoff", 
                "Fuel source separation", 
                "Motor control center (MCC) panel enclosure", 
                "Coupler lock", 
                "Explosion suppression system", 
            ]}, 
            {title: "Excavation or Trench", img: pressure2img, options: [
                "Hard physical barrier", 
                "Covers over holes / trenches", 
                "Sloping and benching", 
                "Trench box", 
                "Excavation support system", 
            ]}, 
        ]}, 
        {title: "Biological", img: biologicalimg, options: [
            {title: "Life-Threatening Animal & Insect Attack, Sewage", img: biological1img, options: [
                "Snake Gaiter Leg Guards", 
                "Dog Bite Stick", 
                "Respirator", 
            ]}, 
        ]}, 
        {title: "Electrical", img: electricalimg, options: [
            {title: "Electrical Contact with High Energy Source", img: electrical1img, options: [
                "Cover up", 
                "Lock-out tag-out", 
                "Tool that forces MAD safe distance", 
                "De-energization with zero voltage test", 
                "Grounding", 
                "Insulating barriers", 
                "Insulating nonconductive PPE gloves, sleeves, shoes, etc.", 
                "Electrical hazard / dielectric footwear", 
                "Ground fault circuit interrupters", 
                "Hot line sticks", 
                "Remote racking devices", 
                "Equipotential zones", 
                "Insulated and / or voltage-rated euipment and tools", 
                "Physical Barriers / Exclusion Zone"
            ]}, 
            {title: "Arc Flash", img: electrical2img, options: [
                "Lock out tag-out", 
                "Tool that forces MAD safe distance", 
                "Motor control center (MCC) panel enclosure", 
                "De-energization with zero voltage test", 
                "Insulating PPE gloves, sleeves, shoes, etc.", 
                "Flash-rated suit, glasses, face shield", 
                "Fire-resistant (FR) clothing", 
                "Remote racking devices", 
                "Flash protection boundary with hard physical barriers", 
                "Hot line sticks", 
            ]}, 
        ]}, 
        {title: "Motion", img: motionimg, options: [
            {title: "Mobile Equipment / Traffic with Workers on Foot", img: motion1img, options: [
                "Walkway / worker on foot physical barriers exclusion zone",
                "Traffic control zone with physical barriers", 
                "Mobile equipment ignition lock-out Tag-out", 
            ]}, 
            {title: "ATV / OUV (occupant)", img: motion2img, options: [
                "Rollover protection system", 
                "Seat belt", 
                "DOT Helmet", 
                "Speed governor key", 
            ]}, 
        ]}, 
        {title: "Chemical / Radiation", img: chemicalRadiationimg, options: [
            {title: "High Dose of Toxic Chemical or Radiation", img: chemicalRadiation1img, options: [
                "Lock-out tag-out", 
                "Local ventilation", 
                "Respirator", 
                "Radiation shielding", 
                "Chemical suit and gloves", 
            ]},  
        ]}, 
    ];
    const hazardControlData = [
        "Slips / Trips / Falls", 
        "Driving", 
        "Flammable", 
        "Combustible", 
        "Chemical", 
        "Temp: Heat / Cold", 
        "Noise", 
        "Electrical", 
        "Pinch Points", 
        "Weather", 
        "Uneven Surface", 
        "Vac Truck Boom", 
        "Open Utility Manhole", 
        "Open Pothole", 
        "Open Trench", 
        "Moving Equipment", 
        "Backing up Vehicles", 
        "Flying Debris", 
        "Air/hydro Lance & Nosel", 
        "Vacuum Hose", 
        "Air Tools", 
        "Hand Saws", 
        "Core Drills", 
        "Animals"
    ];
    const confinedSpaceHotWork = [
        "Does Task Present Confined Space Hazards?", 
        "Do We need air Monitoring?", 
        "Will there be Hot Work?", 
        "Do we need a permit?", 
        "Is Fire Watch required?", 
        "Are respirators needed?", 
        "Do we need attendant?"
    ];
    const confinedSpaceHotWorkNames = [
        "confinedSpaceHazard", 
        "airMonitoring", 
        "hotWork",   
        "permit", 
        "fireWatch", 
        "respirators", 
        "attendant"
    ];
    //-------------------------------------------------------------------------------------------
    const curContent = normalizeJsaContent(jobSafetyAnalysisContent);
    // dynamic module
    const [hazardControls, setHazardControls] = useState(curContent.hazardControls?
        parseMaybeJson(curContent.hazardControls, []):[]
    );
    const defaultSIF = Object.fromEntries(sifList.map(sif => [sif.title, {
        selected: false, 
        inputHazard: "", 
        inputControls: "", 
        content: Object.fromEntries(
            sif.options.map(hazard => [hazard.title, []])
        )
    }]));
    const [sif, setSIF] = useState(curContent.sif?
        parseMaybeJson(curContent.sif, defaultSIF):defaultSIF
    );
    /*-------------------------------------------------------------*/
    // others module
    const [others, setOthers] = useState(curContent.others?
        parseMaybeJson(curContent.others, {}):{}
    );
    //-------------------------------------------------------------------------------------------
    const realTime = useMemo(() => `${(new MyDate()).s()} ${(new MyDate()).ss()}`, []);
    /*-------------------------------------------------------------*/
    // content
    const [curSel1, setCurSel1] = useState(curContent.sel1 ?? "");
    const [curConfinedWork, setConfinedWork] = useState(curContent.sel3 ?? "");
    const [ppe, setPPE] = useState(false);
    //-------------------------------------------------------------------------------------------
    const faceData = [
        "Safety Glasses", 
        "Chemical Goggles", 
        "Impact Goggles", 
        "Full Face shield", 
        "Cutting goggles"
    ];
    const [eyeFace, setEyeFace] = useState(curContent.eyeFace?
        (Array.isArray(curContent.eyeFace)?curContent.eyeFace:curContent.eyeFace.split(", "))
        .filter(eyeFaceItem => faceData.includes(eyeFaceItem)):[]);
    const handData = [
        "Cloth", 
        "Leather", 
        "Welding", 
        "Metal mesh", 
        "Electriacl Insulated", 
        "Rubber", 
        "Kevlar", 
        "Latex", 
        "Vinyl", 
        "Butyl", 
        "Nitrile"
    ];
    const [handGloves, setHandGloves] = useState(curContent.handGloves?
        (Array.isArray(curContent.handGloves)?curContent.handGloves:curContent.handGloves.split(", "))
        .filter(handGlovesItem => handData.includes(handGlovesItem)):[]);
    const footData = [
        "Hard toe shoes / boots", 
        "Dielectric", 
        "Neoprene", 
        "Rubber", 
        "PVC / Urethane", 
        "Metatarsul guard"
    ];
    const [foot, setFoot] = useState(curContent.foot?
        (Array.isArray(curContent.foot)?curContent.foot:curContent.foot.split(", "))
        .filter(footItem => footData.includes(footItem)):[]);
    const headData = [
        "Class 'E' Hard hat ANSI Z89.1,2009 TYPE I"
    ];
    const [head, setHead] = useState(curContent.head?
        (Array.isArray(curContent.head)?curContent.head:curContent.head.split(", "))
        .filter(headItem => headData.includes(headItem)):[]);
    const gasDetectorData = [
        "Multi Gas Detector", 
        "H2S Gas Monitor Test daily"
    ];
    const [gasDetector, setGasDetector] = useState(curContent.gasDetector?
        (Array.isArray(curContent.gasDetector)?curContent.gasDetector:curContent.gasDetector.split(", "))
        .filter(gasDetectorItem => gasDetectorData.includes(gasDetectorItem)):[]);
    const respiratoryProtectionData =  [
        "Dust mask", "Fume / mist mask", 
        "Half face filter", 
        "Full face filter", 
        "Full face airline", "Half face SCBA", 
        "Emergency escape pack", "N95 mask"
    ];
    const [respiratoryProtection, setRespiratoryProtection] = useState(curContent.respiratoryProtection?
        (Array.isArray(curContent.respiratoryProtection)?curContent.respiratoryProtection:curContent.respiratoryProtection.split(", "))
        .filter(respiratoryProtectionItem => respiratoryProtectionData.includes(respiratoryProtectionItem)):[]);
    const protectiveClothingData = [
        "Nomex / FRC", 
        "Tyvek suits", 
        "Rain Suit", 
        "Acid Suit"
    ];
    const [protectiveClothing, setProtectiveClothing] = useState(curContent.protectiveClothing?
        (Array.isArray(curContent.protectiveClothing)?curContent.protectiveClothing:curContent.protectiveClothing.split(", "))
        .filter(protectiveClothingItem => protectiveClothingData.includes(protectiveClothingItem)):[]);
    const hearingData = [
        "Ear plugs", 
        "Canal cap", 
        "Ear muffs", 
        "Dual Protection"
    ];
    const [hearing, setHearing] = useState(curContent.hearing?
        (Array.isArray(curContent.hearing)?curContent.hearing:curContent.hearing.split(", "))
        .filter(hearingItem => hearingData.includes(hearingItem)):[]);
    const fallProtectionData = [
        "Fall Body Harness / 2 Lanyards", 
        "Static Line", 
        "Vertical Life Line"
    ];
    const [fallProtectionList, setFallProtectionList] = useState(curContent.fallProtectionList?
        (Array.isArray(curContent.fallProtectionList)?curContent.fallProtectionList:curContent.fallProtectionList.split(", "))
        .filter(fallProtection => fallProtectionData.includes(fallProtection)):[]);
    //--------------------------------------------------------------------------------------------
    const fillTestData = () => {
        const setInputValue = (id: string, value: string) => {
            const input = document.getElementById(id) as HTMLInputElement | HTMLTextAreaElement | null;
            if(!input) return;
            input.value = value;
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));
        };
        const setChecked = (id: string) => {
            const input = document.getElementById(id) as HTMLInputElement | null;
            if(!input) return;
            input.click();
        };

        setInputValue("loc", `${location || "Test Site"} - North Access`);
        setInputValue("loc2", curContent.loc2 || nearestMedicalFacility || "Nearest urgent care 10 minutes east");
        setInputValue("loc3", "Primary evacuation point at front gate");
        setInputValue("loc4", "Eyewash and first aid kit inside field truck");

        setChecked("check1Yes");
        setCurSel1("Yes");
        setChecked("sel2Yes");
        setConfinedWork("Yes");

        window.requestAnimationFrame(() => {
            confinedSpaceHotWorkNames.forEach((name, index) => {
                const ids = [
                    `${name}yes`,
                    `${name}no`
                ];
                setChecked(index < 3 ? ids[0] : ids[1]);
            });
        });

        setHazardControls([
            {
                hazard: "Driving",
                others: false,
                otherHazard: "",
                control: "Use spotter, inspect route, maintain 360 awareness, and keep exclusion zone."
            },
            {
                hazard: "Moving Equipment",
                others: false,
                otherHazard: "",
                control: "Establish work zone barriers and maintain communication with operators."
            }
        ]);

        setEyeFace(["Safety Glasses"]);
        setHandGloves(["Leather"]);
        setFoot(["Hard toe shoes / boots"]);
        setHead(["Class 'E' Hard hat ANSI Z89.1,2009 TYPE I"]);
        setGasDetector(["Multi Gas Detector"]);
        setRespiratoryProtection(["N95 mask"]);
        setProtectiveClothing(["Nomex / FRC"]);
        setHearing(["Ear plugs"]);
        setFallProtectionList(["Fall Body Harness / 2 Lanyards"]);
        setPPE(true);

        setOthers({
            eyeFaceContent: "Tinted face shield for glare",
            handGlovesContent: "Cut resistant liner",
            notes: "Generated test content"
        });

        setSIF(prev => ({
            ...prev,
            Mechanical: {
                ...prev.Mechanical,
                selected: true,
                inputHazard: "Rotating drill and moving tooling near operator position",
                inputControls: "Maintain guarding and hands-free tooling",
                content: {
                    ...prev.Mechanical.content,
                    "Heavy Rotating Equipment": [
                        "Machine guards",
                        "Safe Hand \"hand-free\" push, pull, grab tool",
                        "Eye protection"
                    ]
                }
            },
            Gravity: {
                ...prev.Gravity,
                selected: true,
                inputHazard: "Dropped tools and fall exposure around excavation edge",
                inputControls: "Use exclusion zone and fall restraint",
                content: {
                    ...prev.Gravity.content,
                    "Suspended Load / Dropped Objects": [
                        "Tool tethers",
                        "Drop Zone Physical Barriers / Exclusion Zone"
                    ],
                    "Fall from Elevation": [
                        "Fall arrest system",
                        "Guard rails"
                    ]
                }
            }
        }));

        setInputValue("additionalPPE", "High visibility vest, sunscreen, cooling towels");
        setInputValue("notes", "Backend test payload generated from JSAContent.");
    };

    const hasInvalidSifControls = () => Object.entries(sif).some(([key, val]) => {
        if(val.selected && (Object.values(val.content).reduce(arrayReducer, []).length === 0 && val.inputControls === "")){
            window.alert(`No control for ${key}.`);
            return true;
        }
        return false;
    });

    const validateSubmitSignatures = () => {
        if(formId){
            if(formAssignmentId === assignmentId){
                if(!picData.length){
                    window.alert(mainLaborName + " need to sign.");
                    return false;
                }
            }else{
                const sign = internalPicDatas.find(item => item.assignmentId === assignmentId);
                if(!sign?.data?.length){
                    window.alert(sign?.laborName + " need to sign.");
                    return false;
                }
            }
        }else if(!picData.length){
            window.alert((userName || user.userName) + " need to sign.");
            return false;
        }
        const unsignedCostomer = picDatas.find(item => !item.data.length);
        if(unsignedCostomer){
            window.alert(unsignedCostomer.name + " need to sign.");
            return false;
        }
        return true;
    };

    const buildJsaFormValues = (formEl, { forSave = false } = {}) => {
        const baseValues = Object.fromEntries(new FormData(formEl).entries());
        const sign = document.getElementById("esign");
        return {
            ...baseValues,
            assignmentId,
            formId: formId || "",
            forSave: forSave ? "yes" : "no",
            openDateTime: realTime,
            eyeFace,
            handGloves,
            foot,
            head,
            gasDetector,
            respiratoryProtection,
            protectiveClothing,
            hearing,
            fallProtectionList,
            helpers: formId ? helpers : {},
            others,
            sif,
            hazardControls,
            jobSafetyAnalysisSign: picData,
            jobSafetyAnalysisInternalSigns: internalPicDatas,
            jobSafetyAnalysisSigns: picDatas,
            sign: !forSave && sign ? sign.toDataURL() : "",
            signs: !forSave ? picDatas.map((_, ii) => {
                const canvas = document.getElementById(`esignOut${ii}`);
                return canvas ? canvas.toDataURL() : "";
            }).filter(Boolean) : [],
            iSigns: !forSave ? internalPicDatas.map((_, ii) => {
                const canvas = document.getElementById(`esignIn${ii}`);
                return canvas ? canvas.toDataURL() : "";
            }).filter(Boolean) : [],
        };
    };

    const createJsaRequestData = (formEl, { forSave = false } = {}) => {
        const formValues = buildJsaFormValues(formEl, { forSave });
        const requestData = new FormData();
        requestData.append("assignmentId", assignmentId);
        if(formId) requestData.append("formId", formId);
        if(forSave) requestData.append("forSave", "yes");
        requestData.append("formValues", JSON.stringify(formValues));
        return requestData;
    };

    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        e.preventDefault();
        if(hasInvalidSifControls()) return;
        if(!validateSubmitSignatures()) return;
        const formData = createJsaRequestData(e.currentTarget);
        submit(formData, { method: "post" });
    }
 
    const handleFormSave = async e => {
        if(hasInvalidSifControls()) return;
        const formData = createJsaRequestData(e, { forSave: true });
        submit(formData, { method: "post" });
    }
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new FormData();
            formData.append("assignmentId", assignmentId);
            if(formId) formData.append("formId", formId);
            formData.append("action", "Read");
            //---------------------------------------------------
            const res =  await myAxios({ fileName: "assignments/jsa.php", formData: formData });
            if(!isMounted) return;
            if(!res) return;
            //---------------------------------------------------
            const nextInternalSigns = parseMaybeJson(res.data.internalSigns, []);
            const nextSign = parseMaybeJson(res.data.sign, []);
            const nextSigns = parseMaybeJson(res.data.signs, []);
            setInternalPicDatas(nextInternalSigns);
            setPicData(nextSign);
            setPicDatas(nextSigns);
            setPPE(Array.isArray(nextSign) ? nextSign.length > 0 : Boolean(nextSign));
            if(formId){
                setMainLaborCategory(res.data.laborCategory);
                setMainLaborName(res.data.laborName);
            }
        }
        getData();
        return () => {isMounted = false;}
    },[ assignmentId, formId, setMainLaborCategory, setMainLaborName ])
    //--------------------------------------------------------------------------------------------
    return(
        <Form onSubmit = {handleFormSubmit}>
            <h3 className = "my-3">{formTitle}</h3>
            <div>
                <div className = "m-2">
                    opened at {realTime}
                </div>
                <div className = "m-2">
                    <button
                        type = "button"
                        className = "btn btn-outline-secondary"
                        onClick = {fillTestData}
                    >
                        Fill Test Data
                    </button>
                </div>
                <h3 className = "my-4 text-danger">
                    <span className = "required-field"></span>This form must be completed prior to work start.
                </h3>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <span className = "required-field text-nowrap">Construct Smarter Project Name:</span>
                    <input
                        id = "pn"
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ms-2"
                        disabled
                        value = {projectName}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap" htmlFor="loc">Job Location:</label>
                    <input
                        id = "loc"
                        name = "loc"
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ms-2"
                        defaultValue = {location}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap" htmlFor="loc2">Location of Nearest Medical Facility:</label>
                    <input
                        name = "loc2"
                        id = "loc2"
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ms-2"
                        defaultValue = {curContent.loc2 || nearestMedicalFacility}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap" htmlFor="loc3">Location of Nearest Evacuation Point:</label>
                    <input
                        name = "loc3"
                        id = "loc3"
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ms-2"
                        defaultValue = {curContent.loc3}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap" htmlFor="loc4">Location of Nearest Eyewash / Fire Extinguisher / First Aid:</label>
                    <input
                        id = "loc4"
                        name = "loc4"
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ms-2"
                        defaultValue = {curContent.loc4}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Valid USA Ticket?</div>
                    <label htmlFor = {`check1Yes`} className = "d-inline ms-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`check1Yes`}
                        name = {"check1"}
                        defaultChecked = {curContent.check1 === "Yes"}
                        value = "Yes"
                        className = "checkboxSquare ms-2"
                    />
                    <label htmlFor = {`check1NA`} className = "d-inline ms-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`check1NA`}
                        name = {"check1"}
                        defaultChecked = {curContent.check1 === "NA"}
                        value = "NA"
                        className = "checkboxSquare ms-2"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Have you controlled any potential water runoff for hydrovac excavation?</div>
                    <label htmlFor = {`sel1Yes`} className = "d-inline ms-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1Yes`}
                        name = {"sel1"}
                        checked = {curSel1 === "Yes"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "Yes"
                        className = "checkboxSquare ms-2"
                    />
                    <label htmlFor = {`sel1No`} className = "d-inline ms-3">No</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1No`}
                        name = {"sel1"}
                        checked = {curSel1 === "No"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "No"
                        className = "checkboxSquare ms-2"
                    />
                    <label htmlFor = {`sel1NA`} className = "d-inline ms-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1NA`}
                        name = {"sel1"}
                        checked = {curSel1 === "NA"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "NA"
                        className = "checkboxSquare ms-2"
                    />
                </div>
                {curSel1 === "No"?
                    <div className = "mb-3 text-danger fw-bold">Please submit an Equipment Damage Report for this ASAP.</div>
                    :<></>}
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Have you examined the entire site for any potential hazards that could affect operations?</div>
                    <label htmlFor = {`sel2Yes`} className = "d-inline ms-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel2Yes`}
                        name = {"sel2"}
                        defaultChecked = {curContent.sel2 === "Yes"}
                        value = "Yes"
                        className = "checkboxSquare ms-2"
                    />
                    <label htmlFor = {`sel2NA`} className = "d-inline ms-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel2NA`}
                        name = {"sel2"}
                        className = "checkboxSquare ms-2"
                        defaultChecked = {curContent.sel2 === "NA"}
                        value = "NA"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Confined Space / Hot Work?</div>
                    <label htmlFor = {`sel3Yes`} className = "ms-3 d-inline">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel3Yes`}
                        name = {"sel3"}
                        checked = {curConfinedWork === "Yes"}
                        onChange = {e => setConfinedWork(e.currentTarget.value)}
                        value = "Yes"
                        className = "checkboxSquare ms-2"
                    />
                    <label htmlFor = {`sel3NA`} className = "d-inline ms-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel3NA`}
                        name = {"sel3"}
                        checked = {curConfinedWork === "NA"}
                        onChange = {e => setConfinedWork(e.currentTarget.value)}
                        value = "NA"
                        className = "checkboxSquare ms-2"
                    />
                </div>
                {curConfinedWork === "Yes"?
                <>
                <h3 className = "mt-4">Confined Space / Hot Work</h3>
                {confinedSpaceHotWork.map((question , key) => 
                    <div key = {key} className = "d-flex align-items-center blk5 mb-2">
                        <div className = "required-field">{question}</div>
                        <label htmlFor = {`${confinedSpaceHotWorkNames[key]}yes`} className = "d-inline ms-3">Yes</label>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`${confinedSpaceHotWorkNames[key]}yes`}
                            name = {confinedSpaceHotWorkNames[key]}
                            defaultChecked = {curContent[confinedSpaceHotWorkNames[key]] === "yes"}
                            value = "yes"
                            className = "checkboxSquare ms-2"
                        />
                        <label htmlFor = {`${confinedSpaceHotWorkNames[key]}no`} className = "d-inline ms-3">No</label>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`${confinedSpaceHotWorkNames[key]}no`}
                            name = {confinedSpaceHotWorkNames[key]}
                            defaultChecked = {curContent[confinedSpaceHotWorkNames[key]] === "no"}
                            value = "no"
                            className = "checkboxSquare ms-2"
                        />
                    </div>
                )}
                </>
                :<></>}
            </div>
            {/************************************************/}
            <div className = "mb-4">
                <h3 className = "mt-4 mb-2">Potential Serious Injury & Fatality (SIF) Suggested Tailboard Topics</h3>
                <img alt = "" src = {signimg} className = "d-block mx-auto"/>
                {sifList.map(item => 
                <div key = {item.title}>
                    <h5 className = "d-flex align-items-center">
                        <label htmlFor = {`sifs${item.title}`} className = "d-inline">{item.title}</label>
                        <input
                            id = {`sifs${item.title}`}
                            type = "checkbox"
                            className = "checkboxSquare ms-2"
                            checked = {sif[item.title].selected}
                            onChange = {e => {
                                const checked = e.currentTarget.checked;
                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], selected: checked}}));
                            }}
                        />
                    </h5>
                    {sif[item.title].selected?
                    <div className = "mb-5">
                        <div className = "d-flex">
                            <label htmlFor = {`${item.title} Hazard`} className = "text-nowrap">Hazard</label>
                            <textarea
                                required
                                id = {`${item.title} Hazard`}
                                className = "form-control w-100 ms-2"
                                value = {sif[item.title].inputHazard}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    setSIF(sif => ({...sif, [item.title]: {...sif[item.title], inputHazard: value}}));
                                }}
                            />
                        </div>
                        {item.options.map(hazard => 
                        <div key = {hazard.title} className = "d-flex align-items-center">
                            <img alt = "" src = {hazard.img} className = "d-block"/>
                            <ul>
                                {hazard.options.map((control, controlIndex) => 
                                <li key = {controlIndex} className = "d-flex align-items-center my-2">
                                    <input
                                        id = {`sifs${hazard.title}${control}`}
                                        type = "checkbox"
                                        className = "checkboxSquare"
                                        checked = {sif[item.title].content[hazard.title].includes(control) || false}
                                        onChange = {e => {
                                            const checked = e.currentTarget.checked;
                                            if(checked){
                                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], 
                                                    content: {...sif[item.title].content, [hazard.title]: [...sif[item.title].content[hazard.title], control]}}})
                                                );
                                            }else{
                                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], 
                                                    content: {...sif[item.title].content, [hazard.title]: sif[item.title].content[hazard.title].filter(ctl => ctl !== control)}}})
                                                );
                                            }
                                        }}
                                    />
                                    <label htmlFor = {`sifs${hazard.title}${control}`} className = "d-inline ms-3">{control}</label>
                                </li>)}
                            </ul>
                        </div>)}
                        <div className = "d-flex">
                            <label htmlFor = {`${item.title} Other Controls`} className = "text-nowrap">Other Controls</label>
                            <textarea
                                id = {`${item.title} Other Controls`}
                                className = "form-control w-100 ms-2"
                                value = {sif[item.title].inputControls}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    setSIF(sif => ({...sif, [item.title]: {...sif[item.title], inputControls: value}}));
                                }}
                            />
                        </div>
                    </div>
                    :<></>}
                </div>
                )}
            </div>
            {/************************************************/}
            <h3 className = "mt-4 mb-2">Secondary Hazard Control</h3>
            {hazardControls.map((hazardControl, key) => 
            <div key = {key}>
            <h5 className = "mb-2">Hazard {key + 1}</h5>
            <div>
                <div className = "required-field mb-2">Hazard:</div>
                {[
                    [0, 5], 
                    [5, 10], 
                    [10, 15], 
                    [15, 20], 
                    [20]
                ].map((sliced, slicedIndex, self) => 
                <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2">
                    {hazardControlData.slice(...sliced).map((option, k) => <div className = "d-flex align-items-center mb-2" key = {k}>
                    <input
                        type = "radio"
                        required = {true}
                        name = {`hazardControlHazard${key}`}
                        id = {`hazardControlHazard${key}${option}`}
                        checked = {hazardControl.hazard === option}
                        onChange = {() => {
                            setHazardControls([
                                ...hazardControls.slice(0, key), 
                                {...hazardControl, 
                                    hazard: option,
                                    others: false
                                }, 
                                ...hazardControls.slice(key + 1)]
                            );
                        }}
                        className = {`checkboxSquare${k === 0?"":" ms-3"}`}
                    />
                    <label htmlFor = {`hazardControlHazard${key}${option}`} className = "d-inline ms-2">{option}</label>
                    </div>)}
                    {slicedIndex === self.length - 1?<>
                    <div className = "d-flex align-items-center mb-2">
                        <input
                            type = "radio"
                            required = {true}
                            name = {`hazardControlHazard${key}`}
                            id = {`hazardControlHazard${key}Others`}
                            checked = {hazardControl.hazard === "Others"}
                            onChange = {() => {
                                setHazardControls([
                                    ...hazardControls.slice(0, key), 
                                    {...hazardControl, 
                                        hazard: "Others",
                                        others: true
                                    }, 
                                    ...hazardControls.slice(key + 1)]
                                );
                            }}
                            className = {`checkboxSquare${hazardControlData.slice(...self[self.length - 1]).length === 0?"":" ms-3"}`}
                        />
                        <label htmlFor = {`hazardControlHazard${key}Others`} className = "d-inline ms-2">Others</label>
                    </div>
                    {hazardControl.others?
                    <input
                        placeholder = "Please specify"
                        required = {true}
                        className = "form-control"
                        value = {hazardControl.otherHazard}
                        onChange = {e => {
                            setHazardControls([
                                ...hazardControls.slice(0, key), 
                                {...hazardControl, 
                                    otherHazard: e.currentTarget.value
                                }, 
                                ...hazardControls.slice(key + 1)]
                            );
                        }}
                    />:null}
                    </>:<></>}
                </div>)}
            </div>
            <div className = "d-flex align-items-center blk5 mb-2">
                <label className = "required-field text-nowrap">Control</label>
                <textarea
                    required = {true}
                    className = "form-control w-100 ms-2"
                    rows = {4}
                    value = {hazardControl.control}
                    onChange = {e => {
                        setHazardControls([
                            ...hazardControls.slice(0, key), 
                            {...hazardControl, 
                                control: e.currentTarget.value
                            }, 
                            ...hazardControls.slice(key + 1)]
                        );
                    }}
                />
            </div>
            <span
                className = "btn btn-danger"
                onClick = {() => {
                    setHazardControls([...hazardControls.slice(0, key), ...hazardControls.slice(key + 1)]);
                }}
            >
                Delete Hazard
            </span>
            </div>)}
            <div className = "my-3">
                <span
                    className = "btn btn-primary"
                    onClick = {() => {
                        setHazardControls([...hazardControls, {hazard: "", others: false, otherHazard:"", control: ""}]);
                    }}
                >
                    Add Hazard
                </span>
            </div>
            {/************************************************/}
            <h3 className = "mt-4 mb-2">PPE Checklist - Check all that apply</h3> 
            <h5 className = "mb-2">Eye & Face</h5>
            {[
                [0, 5], 
                [5]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2">
                {faceData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`eyeFace${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {eyeFace.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setEyeFace([...eyeFace, option].filter(onlyUnique));
                            }else{
                                setEyeFace(eyeFace.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`eyeFace${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {1} before = {faceData.slice(...self[self.length - 1]).length !== 0} title = "eyeFace" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Hand Gloves</h5>
            {[
                [0, 6], 
                [6]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {handData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`handGloves${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {handGloves.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHandGloves([...handGloves, option].filter(onlyUnique));
                            }else{
                                setHandGloves(handGloves.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`handGloves${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {2} before = {handData.slice(...self[self.length - 1]).length !== 0} title = "handGloves" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Foot</h5>
            {[
                [0, 6], 
                [6]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {footData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`foot${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {foot.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setFoot([...foot, option].filter(onlyUnique));
                            }else{
                                setFoot(foot.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`foot${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {3} before = {footData.slice(...self[self.length - 1]).length !== 0} title = "foot" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Head</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {headData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`head${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {head.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHead([...head, option].filter(onlyUnique));
                            }else{
                                setHead(head.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`head${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {4} before = {headData.slice(...self[self.length - 1]).length !== 0} title = "head" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Gas Detector</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {gasDetectorData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`gasDetector${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {gasDetector.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setGasDetector([...gasDetector, option].filter(onlyUnique));
                            }else{
                                setGasDetector(gasDetector.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`gasDetector${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {5} before = {gasDetectorData.slice(...self[self.length - 1]).length !== 0} title = "gasDetector" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Respiratory Protection</h5>
            {[
                [0, 4], 
                [4]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {respiratoryProtectionData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`respiratoryProtection${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {respiratoryProtection.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setRespiratoryProtection([...respiratoryProtection, option].filter(onlyUnique));
                            }else{
                                setRespiratoryProtection(respiratoryProtection.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`respiratoryProtection${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {6} before = {respiratoryProtectionData.slice(...self[self.length - 1]).length !== 0} title = "respiratoryProtection" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Protective Clothing</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {protectiveClothingData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`protectiveClothing${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {protectiveClothing.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setProtectiveClothing([...protectiveClothing, option].filter(onlyUnique));
                            }else{
                                setProtectiveClothing(protectiveClothing.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`protectiveClothing${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {7} before = {protectiveClothingData.slice(...self[self.length - 1]).length !== 0} title = "protectiveClothing" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Hearing</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {hearingData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`hearing${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {hearing.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHearing([...hearing, option].filter(onlyUnique));
                            }else{
                                setHearing(hearing.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`hearing${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {8} before = {hearingData.slice(...self[self.length - 1]).length !== 0} title = "hearing" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Fall Protection</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {fallProtectionData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`fallProtectionList${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ms-3"}`}
                        value = {option}
                        checked = {fallProtectionList.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setFallProtectionList([...fallProtectionList, option].filter(onlyUnique));
                            }else{
                                setFallProtectionList(fallProtectionList.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`fallProtectionList${key}${option}`} className = "ms-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {9} before = {fallProtectionData.slice(...self[self.length - 1]).length !== 0} title = "fallProtectionList" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            {/************************************************/}
            <h5 className = "mb-2">List additional PPE</h5> 
            <div className = "mb-2">
                <textarea
                    rows = {4}
                    className = "form-control w-100"
                    name = "additionalPPE"
                    defaultValue = {curContent.additionalPPE}
                />
            </div>
            <div className = "mt-3 mb-1 text-danger fw-bold">If conditions change, STOP THE JOB, seek advice, including discussion on new hazards and identification of controls, and update this section of the JSA with time of change and additional hazards and controls. Document personnel included in the tailboard update.</div>
            <h5 className = "mb-2">Job Scope change / Additional Hazard / Notes</h5> 
            <div className = "mb-2">
                <textarea
                    rows = {4}
                    className = "form-control w-100"
                    name = "notes"
                    defaultValue = {curContent.notes}
                />
            </div>
            <ul className = "text-danger fw-bold">
                <li>Assign roles responsibilities in case of an accident, emergency or abnormal condition. In the event of serious injury or fatality call 911, and make the area safe. As soon as it is safe to do so, call the safety manager with information about the emergency and call the supervisor.</li>
                <li>Verify that crew members know their own and other crew members' tasks and roles.</li>
                <li>All employees have the right, authority, obligation and responsibility to STOP THE JOB if an imminent hazard or serious perceived danger exists. Stop the job, notify the Person in Charge (PIC), investigate/evaluate, correct unsafe situations and resume when safe.</li>
            </ul>
            <div className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "text-nowrap equired-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        value = {formId?mainLaborName:(userName || user.userName)}
                        name = "memberName"
                        readOnly
                    />
                    <label className = "text-nowrap required-field ms-2">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        value = {formId?mainLaborCategory:laborCategory}
                        readOnly
                    />
                    <label className = "text-nowrap required-field ms-2">Date:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        defaultValue = {(new MyDate()).s()}
                        name = "submitDate"
                        readOnly
                    />
                </div>
                <label htmlFor = "signPPE" className = "fw-bold inline">My PPE is in a condition to effectively protect against hazards.</label>
                <input
                    type = "radio"
                    id = {"signPPE"}
                    checked = {ppe}
                    onChange = {() => setPPE(true)}
                    className = "checkboxSquare ms-3"
                />
                {ppe?
                <Esign
                    buttonClassName = "my-2"
                    picData = {picData}
                    setPicData = {setPicData}
                />
                :<></>}
            </div>
            {internalPicDatas.map((x, xi) => 
            <div key = {xi} className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "text-nowrap required-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        value = {x.laborName}
                        readOnly
                    />
                    <label className = "text-nowrap required-field ms-2 text-nowrap">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        value = {x.laborCategory}
                        readOnly
                    />
                    <label className = "text-nowrap required-field ms-2">Date:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        value = {(new MyDate()).s()}
                        readOnly
                    />
                </div>
                {formId?
                <div className = "d-flex my-3">
                    <label className = "h5 inline">Include in this Form</label>
                    <input
                        type = "checkbox"
                        className = "checkboxSquare ms-2"
                        checked = {helpers[x.assignmentId] !== undefined}
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setHelpers(helpers => ({...helpers, [x.assignmentId]: ""}));
                            }else{
                                if(![undefined, ""].includes(helpers[x.assignmentId]) && !window.confirm("Are you sure to delete this sign?")) return;
                                const temp = {...helpers};
                                delete(temp[x.assignmentId]);
                                setHelpers(temp);
                            }
                        }}
                    />
                 </div>
                 :<></>}
                {!formId || helpers[x.assignmentId] !== undefined?<div>
                <label htmlFor = {`signPPF${xi}`} className = "fw-bold inline">My PPE is in a condition to effectively protect against hazards.</label>
                <input
                    type = "radio"
                    id = {`signPPF${xi}`}
                    checked = {x.ppe === "yes"}
                    onChange = {() => {
                        setInternalPicDatas(internalPicDatas => internalPicDatas.map((internalPicData, i) => xi === i?({
                            ...internalPicData,
                            ppe: "yes"
                        }):internalPicData));
                    }}
                    className = "checkboxSquare ms-3"
                />
                {x.ppe === "yes"?
                <Esigns
                    buttonClassName = "my-3"
                    signIndex = {xi}
                    id = {`In${xi}`}
                    picDatas = {internalPicDatas} 
                    setPicDatas = {setInternalPicDatas}
                    prefix = {`Internal`} 
                    disableDefaultSign
                />
                :<></>}
                </div>
                :<></>}
            </div>
            )}
            {picDatas.map((x, xi) => 
            <div key = {xi} className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "text-nowrap required-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        required
                        value = {x.name}
                        onChange = {e => {
                            setPicDatas([...picDatas.slice(0, xi),{...picDatas[xi], name: e.currentTarget.value},...picDatas.slice(xi + 1)]);
                        }}
                    />
                    <label className = "text-nowrap required-field ms-2">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ms-2"
                        required
                        value = {x.role}
                        onChange = {e => {
                            setPicDatas([...picDatas.slice(0, xi),{...picDatas[xi], role: e.currentTarget.value},...picDatas.slice(xi + 1)]);
                        }}
                    />
                    <label className = "text-nowrap required-field ms-2">Date:</label>
                    <input
                        type = "date"
                        min = "1900-01-01"
                        max = "2999-12-31"
                        required
                        className = "form-control ms-2"
                        value = {x.date}
                        onChange = {e => setPicDatas([
                            ...picDatas.slice(0, xi),
                            {
                                ...picDatas[xi], 
                                date: e.currentTarget.value
                            },
                            ...picDatas.slice(xi + 1)
                        ])}
                    />
                </div>
                <Esigns 
                    buttonClassName = "my-3"
                    signIndex = {xi}
                    id = {`Out${xi}`}
                    picDatas = {picDatas} 
                    setPicDatas = {setPicDatas}
                    prefix = {`Customer`} 
                    disableDefaultSign
                />
                <span className = "btn btn-danger" onClick = {() => {
                    setPicDatas([...picDatas.slice(0, xi),...picDatas.slice(xi + 1)]);
                }}>Delete This Signature</span>
            </div>
            )}
            <span className = "btn btn-primary mb-2" onClick = {e => {
                setPicDatas([...picDatas, {data:[], name: "", date: "", role: ""}]);
            }}>Add Signature</span>
            <ul className = "my-2 text-danger fw-bold @text-uppercase">
                <li>If injury occurred, Immediately report the incident, injury, event or issue to the site superintendent or safety representative. </li>
                <li>In case of an incident, the following safety reps will be contacted: 
                    <ul>
                    {jsaManagers.map((jsaManager, jsaManagerIndex) => <li key = {jsaManagerIndex}><UserInfo name = {jsaManager.name} email = {jsaManager.email}/> <a href = {"tel:+1" + jsaManager.tel.replace(/-/g, "")}>{jsaManager.tel}</a></li>)}
                    </ul>
                </li>
                <li>Nurse on Call:&nbsp;
                    {jsaOnsiteNumbers.map((jsaOnsiteNumber, jsaOnsiteNumberIndex) => <a key = {jsaOnsiteNumberIndex} href = {"tel:+1" + jsaOnsiteNumber.replace(/-/g, "")}>{jsaOnsiteNumber}</a>)}
                </li>
            </ul>
            <div className="py-3 d-flex gap-2">
                <button
                    type = "button"
                    className = "btn btn-success"
                    onClick = {e => handleFormSave(e.currentTarget.form)}
                >
                    Save
                </button>
                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
                <button
                    type = "button"
                    className = "btn btn-outline-secondary ms-auto"
                    onClick = {closeIt}
                >
                    Back
                </button>
            </div>
        </Form>
    )    
}
